import { AxiosResponse } from 'axios';
import { csrfToken, instance } from '../db';

// 大分類マスタの取得
export const getCategoryList = async (): Promise<AxiosResponse> => {
  const response = await instance.get('/categories', {
    headers: {
      'X-XSRF-TOKEN': csrfToken
    }
  });

  return response;
};
